var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"business-contact-topic-create","width":400,"title":"Schwerpunkt erstellen"}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('business-contact-topic-form',{attrs:{"businessContactTopic":_vm.businessContactTopic,"type":"create"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }